<template>
  <figure class="raw-glass rounded-md grid gap-8 p-24">
    <blockquote class="raw-heading-2">
      <p><InlineMarkdown :message="text" /></p>
    </blockquote>

    <figcaption
      v-if="attribution"
      class="raw-body-2 !font-[400] text-[var(--raw-darkgrey)]"
    >
      <InlineMarkdown :message="attribution" />
    </figcaption>
  </figure>
</template>

<script setup lang="ts">
import InlineMarkdown from '~/scopes/campaign/components/UI/InlineMarkdown.vue'
import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'

/**
 * A pull quote with its attribution. `<figure>` + `<figcaption>` rather than
 * `<blockquote>` + `<cite>`: `<cite>` marks the *title of a work*, not the person
 * being quoted, and the figure pattern is the spec's own answer for attributing a
 * quotation — the same vocabulary a captioned photo already uses here.
 *
 * The quotation marks come from the authored copy, so this adds none of its own.
 * Both strings run through `InlineMarkdown`, so an attribution can bold the name.
 */
defineProps<{
  text: I18nDescriptor
  attribution?: I18nDescriptor
}>()
</script>

<style scoped>
/* The dash is punctuation the layout owns, not copy — authoring it into every
   attribution string would make translators responsible for a typographic mark. */
figcaption::before {
  content: '— ';
}

/* `raw-heading-2` carries no leading of its own, so it inherits the body's 1.25.
   That reads tight on a 20px display quote running three or four lines. */
blockquote {
  line-height: 1.35;
}
</style>
